/**
 * Os painéis que saíram das âncoras da `AdminConfigPage` — K-3, caso 2.
 *
 * Três itens do catálogo apontavam para pedaços da mesma página, via âncora
 * (`#financeiro`, `#sistema`, `#seguranca`). Cada um vira painel próprio na
 * casca, e o item passa a ter endereço de verdade em vez de um scroll.
 *
 * ── O recorte do Financeiro, que o handoff mandava resolver aqui
 *
 * Havia UM item chamado "Contas, metas e impostos" cobrindo quatro assuntos
 * distintos. Quem procurava "financiamento" não achava; quem procurava "envio de
 * relatório" também não. Agora são quatro itens, um por card — que é como a
 * `AdminConfigPage` já os organizava internamente.
 */
import { FinanceiroContasConfigCard } from '@/pages/admin/financeiro/FinanceiroContasConfigCard';
import { FinanceiroMetasConfigCard } from '@/pages/admin/financeiro/FinanceiroMetasConfigCard';
import { FinanceiroFinanciamentoConfigCard } from '@/pages/admin/financeiro/FinanceiroFinanciamentoConfigCard';
import { FinanceiroRelatoriosConfigCard } from '@/pages/admin/financeiro/FinanceiroRelatoriosConfigCard';
import { SegurancaLoginConfigCard } from '@/pages/admin/SegurancaLoginConfigCard';

export function PainelFinanceiroContas() {
  return <FinanceiroContasConfigCard />;
}

export function PainelFinanceiroMetas() {
  return <FinanceiroMetasConfigCard />;
}

export function PainelFinanceiroFinanciamento() {
  return <FinanceiroFinanciamentoConfigCard />;
}

export function PainelFinanceiroRelatorios() {
  return <FinanceiroRelatoriosConfigCard />;
}

export function PainelSegurancaLogin() {
  return <SegurancaLoginConfigCard />;
}
